/**
 * @ui-kit/components (Emotion 11 + shell v3) expects React 18 APIs that React 16 does not export.
 * Without this, Menu / PrivateLayout throw "Object(...) is not a function" (e.g. useId, useInsertionEffect).
 * Import this module once, before any `@ui-kit/components` import.
 */
import React from "react";

let useIdSeq = 0;

if (typeof React.useId !== "function") {
    React.useId = function useId() {
        useIdSeq += 1;
        return `r${useIdSeq}`;
    };
}

if (typeof React.useInsertionEffect !== "function") {
    React.useInsertionEffect = React.useLayoutEffect;
}
